(function () {
  const body = document.body;
  const headings = document.querySelectorAll('[data-collapsible-list-heading]');
  let resizeTimeout = null;

  function toggleListState(event) {
    // Allow only one open tab at a time.
    collapseAll();

    // If this is a keyboard event and its key is anything other than Space or
    // Enter, do nothing.
    if (event.key && event.key !== ' ' && event.key !== 'Enter') return;

    // Prevent Space keypress from scrolling the page.
    event.preventDefault();

    const button = this;
    const list = document.getElementById(button.getAttribute('aria-controls'));

    if (button.getAttribute('aria-expanded') === 'true') {
      button.setAttribute('aria-expanded', 'false');
      list.setAttribute('aria-hidden', 'true');
    } else {
      button.setAttribute('aria-expanded', 'true');
      list.setAttribute('aria-hidden', 'false');
    }
  }

  function removeCollapsibleBehavior() {
    for (let i = 0; i < headings.length; i++) {
      const list = headings[i].parentNode.querySelector('[data-collapsible-list-group]');
      list.removeAttribute('id');
      list.removeAttribute('aria-hidden');
      headings[i].removeAttribute('role');
      headings[i].removeAttribute('tabindex');
      headings[i].removeAttribute('aria-expanded');
      headings[i].removeAttribute('aria-controls');
      headings[i].removeEventListener('click', toggleListState);
      headings[i].removeEventListener('keydown', toggleListState);
    }

    body.removeAttribute('data-collapsible-groups');
  }

  function initCollapsibleBehavior() {
    // If already initialized, do nothing.
    if (body.hasAttribute('data-collapsible-groups')) return;

    for (let i = 0; i < headings.length; i++) {
      // Add other elements attributes.
      const list = headings[i].parentNode.querySelector('[data-collapsible-list-group]');
      list.setAttribute('id', 'list-grouping-' + i);

      // Add own attributes.
      headings[i].setAttribute('role', 'button');
      headings[i].setAttribute('tabindex', 0);
      headings[i].setAttribute('aria-expanded', 'true');
      headings[i].setAttribute('aria-controls', list.id);

      // register on toggle event listener.
      headings[i].addEventListener('click', toggleListState);
      headings[i].addEventListener('keydown', toggleListState);
    }

    collapseAll();

    // Mark body as initialized.
    body.setAttribute('data-collapsible-groups', '');
  }

  function collapseAll() {
    const lists = document.querySelectorAll('.search-list__item-container');
    for (let i = 0; i < lists.length; i++) {
      lists[i].setAttribute('aria-hidden', 'true');
    }
    for (let i = 0; i < headings.length; i++) {
      headings[i].setAttribute('aria-expanded', 'false');
    }
  }

  function handlePageResize(e) {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        if (isMobile()) {
          initCollapsibleBehavior();
        } else {
          removeCollapsibleBehavior();
        }
      }, 100);
    }
  }

  if (headings.length) {
    handlePageResize();
    window.addEventListener('resize', handlePageResize);
  }
})(this);
